import abmModelos from './ABMModelos';
import asientosContables from './AsientosContables';
import busquedaCliente from './ClientSearch';
import cliente from './Cliente';
import configuracionProcesos from './ConfiguracionProcesos';
import ConfirmadorAjusteCargo from './ConfirmadorAjusteCargo'
import confirmadorSolicitud from './ConfirmadorSolicitud';
import contabilizadorRecontabilizador from './ContabilizadorRecontabilizador';
import DatosCuenta from './DatosCuenta';
import distribucionLimites from './DistribucionLimites';
import editarConfiguracionProceso from './EditarConfiguracionProceso';
import ingresoAjustes from './IngresoAjustes';
import ingresoCobranzas from './IngresoCobranzas';
import integracionPantallas from './IntegracionPantallas';
import invocadorReportes from './InvocadorReportes';
import listadoProductos from './ListadoProductos';
import modelosContables from './ModelosContables';
import nuevaSolicitud from './NuevaSolicitud';
import panelSeleccion from './PanelSeleccion';
import procesos from './Procesos';
import producto from './Producto';
import saldosResumenes from './SaldosResumenes';
import seleccionCuentas from './SeleccionCuentas';
import tarjetas from './Tarjetas';
import vistaCliente from './VistaCliente';

export default {
    abmModelos,
    asientosContables,
    busquedaCliente,
    cliente,
    configuracionProcesos,
    ConfirmadorAjusteCargo,
    confirmadorSolicitud,
    contabilizadorRecontabilizador,
    DatosCuenta,
    distribucionLimites,
    editarConfiguracionProceso,
    ingresoAjustes,
    ingresoCobranzas,
    integracionPantallas,
    invocadorReportes,
    listadoProductos,
    modelosContables,
    nuevaSolicitud,
    panelSeleccion,
    procesos,
    producto,
    saldosResumenes,
    seleccionCuentas,
    tarjetas,
    vistaCliente
};